<script setup lang="ts">
import { Waline } from '@waline/client/component'
import { useData, useRoute, withBase } from 'vitepress';
import { computed, toRefs } from 'vue';
type TWalineOptions = Record<string, unknown>

type Tprops = {
  options: TWalineOptions
}

const props = withDefaults(defineProps<Tprops>(), { options: () => ({}) })

const route = useRoute()


const { options } = toRefs(props)
const { lang } = useData()

const walineOption = computed(() => ({
  lang: lang.value || 'zh-CN',
  dark: 'html[class="dark"]',
  path: withBase(route.path),
  ...options.value,
  pageview: false,
}))

</script>
<template>
  <Waline v-bind="walineOption" />
</template>

<style lang="scss">
  @import '@waline/client/dist/waline.css';
  .waline-comment .wl-panel {
    @apply bg-code-base;
    @apply border-base;
  }

  .wl-editor:focus,
  .wl-input:focus {
    @apply bg-code-base;
    @apply dark:border-primary/50;
  }
  .wl-actions {
    .wl-action {
      @apply text-base;
      &.actived,
      &:hover {
        @apply text-primary/90;
      }
    }
  }

  .wl-btn:hover,
  .wl-btn:active {
    @apply border-primary text-primary/90;
  }

  .wl-btn.primary {
    @apply border-primary bg-primary;
  }

  .wl-btn.primary:hover,
  .wl-btn.primary:active {
    @apply border-primary bg-primary;
  }

  .wl-sort li.active {
    @apply text-primary/90;
  }

</style>